import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Guest } from '../../assests/ExportImageIcon'
// Lock2, Languages icons unused while Private/Shareable options are disabled below
// EditProfile unused while the cover-image upload block above is commented out
import DatePicker from '../../componants/datePicker/DatePicker'
import service from '../../services/service'
import endpoints from '../../services/endpoints'
import { showToast } from '../../componants/toast/toastService'
import '../onboarding/AccountSetup.css'
import './wishlist.css'

const BackArrow = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M15 9H4M8 5l-4 4 4 4" stroke="#026D4D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const CheckIcon = () => (
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
        <path d="M3 7.2l2.4 2.4L11 4.2" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const PRIVACY_OPTIONS = [
    // { key: 'private', icon: Lock2, title: 'Private', subtitle: 'Only you can see' },
    // { key: 'shareable', icon: Languages, title: 'Shareable', subtitle: 'Anyone with link' },
    { key: 'collaborative', icon: Guest, title: 'Collaborative', subtitle: 'Invite editors' },
]

const CreateWishlist = () => {
    const navigate = useNavigate()
    const [privacy, setPrivacy] = useState('collaborative')
    const [name, setName] = useState('')
    const [destination, setDestination] = useState('')
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')
    const [submitting, setSubmitting] = useState(false)

    const handleContinue = async () => {
        if (!name.trim()) {
            showToast('Please enter a wishlist name', 'error')
            return
        }
        if (submitting) return
        setSubmitting(true)
        try {
            const { data } = await service.post(endpoints.wishlists.create, {
                name: name.trim(),
                destination: destination.trim(),
                date_from: dateFrom || null,
                date_to: dateTo || null,
            })
            const newId = data.data?.id
            if (!newId) throw new Error('Wishlist created but no id returned')
            navigate('/add-wishlist-item', { state: { wishlistId: newId, shareLink: data.data?.share_link } })
        } catch {
            // error toast already shown by the service interceptor
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <>
        <section className='allSearchArea commonTopPadding commonBottomPadding'>
            <div className='container'>
                <div className='row g-4'>
                    <div className='col-md-12'>
                        <div className='commonMaxWidth'>
                            <div className='tripDocHeader mb-4' onClick={() => navigate(-1)}>
                                <BackArrow />
                                <span className='bsSectionTitle'>Create Wishlist</span>
                            </div>
                            <div className='mb-4'>
                                <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    <div className='createWishlistStep__top'>
                                        <span>Details</span>
                                        <span>1/5</span>
                                    </div>
                                    <div className='createWishlistStep__track'>
                                        <div className='createWishlistStep__fill' />
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className='bsSectionTitle'>Enter Few Details</div>
                                <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>

                                    {/* Wishlist cover image upload — not wired to any upload API yet, comment out until built */}
                                    {/* <div className='createWishlistAvatar'>
                                        <span className='createWishlistAvatar__preview'>
                                            <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M4 8.5C4 7.12 5.12 6 6.5 6h1.4c.4 0 .77-.2 1-.53l.8-1.14c.23-.33.6-.53 1-.53h2.6c.4 0 .77.2 1 .53l.8 1.14c.23.33.6.53 1 .53h1.4C18.88 6 20 7.12 20 8.5v8c0 1.38-1.12 2.5-2.5 2.5h-11A2.5 2.5 0 014 16.5v-8z"
                                                    stroke="#fff"
                                                    strokeWidth="1.4"
                                                    strokeLinejoin="round"
                                                />
                                                <circle cx="12" cy="12.5" r="3" stroke="#fff" strokeWidth="1.4" />
                                            </svg>
                                            <span className='createWishlistAvatar__editBadge'>
                                                <img src={EditProfile} alt="" />
                                            </span>
                                        </span>
                                    </div> */}

                                    <div className='accountSetup__field mt-4'>
                                        <label>Wishlist Name</label>
                                        <input
                                            type='text'
                                            placeholder='e.g., Goa Escape 2026'
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                    </div>

                                    <div className='accountSetup__field mt-3'>
                                        <label>Destination(s)</label>
                                        <input
                                            type='text'
                                            placeholder='e.g., Goa'
                                            value={destination}
                                            onChange={(e) => setDestination(e.target.value)}
                                        />
                                    </div>

                                    <div className='accountSetup__field mt-3'>
                                        <label>Dates</label>
                                        <div className='createWishlistDates'>
                                            <div className='createWishlistDateField'>
                                                <DatePicker value={dateFrom} onChange={setDateFrom} />
                                            </div>
                                            <div className='createWishlistDateField'>
                                                <DatePicker value={dateTo} onChange={setDateTo} min={dateFrom || undefined} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='mt-4'>
                                    <div className='bsSectionTitle'>Privacy</div>
                                    <div className='createWishlistPrivacy bgWhite commonBorder borderRadius20 paddingCommon20'>
                                        {PRIVACY_OPTIONS.map((option) => (
                                            <div
                                                key={option.key}
                                                className={`createWishlistPrivacy__item ${privacy === option.key ? 'active' : ''}`}
                                                onClick={() => setPrivacy(option.key)}
                                            >
                                                <span className='createWishlistPrivacy__icon'>
                                                    <img src={option.icon} alt="" />
                                                </span>
                                                <div className='createWishlistPrivacy__text'>
                                                    <div className='createWishlistPrivacy__title'>{option.title}</div>
                                                    <div className='createWishlistPrivacy__subtitle'>{option.subtitle}</div>
                                                </div>
                                                <span className='createWishlistPrivacy__radio'>
                                                    {privacy === option.key && <CheckIcon />}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <button type='button' className='commonBtn w-100 mt-4' onClick={handleContinue} disabled={submitting}>
                                    {submitting ? 'Creating...' : 'Continue'}
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
        </>
    )
}

export default CreateWishlist
